import { Button } from "@mui/material";
import { useState } from "react";
import SimpleDialog from "../../../common/SimpleDialog";
import EditIcon from '@mui/icons-material/Edit';
import { CreateContentProvider } from "../context/CreateContentContext";
import AIContentCreator from "./AIContentCreator";

type Props = {
    onAccept: (updatedText: string) => void,
    contentType: 'SalesPitch'
}

const AIContentCreatorDialog = ({ contentType, onAccept }: Props) => {
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    }

    return (
        <CreateContentProvider initialPrompt='' contentType={contentType}>
            <Button variant="contained" size="small" fullWidth endIcon={<EditIcon />} onClick={() => setOpen(true)}>Create Content</Button>

            <SimpleDialog open={open} onClose={() => setOpen(false)} sx={{ height: '100%' }}>
                <AIContentCreator onClose={handleClose} onAccept={onAccept} />
            </SimpleDialog>
        </CreateContentProvider >
    )
}

export default AIContentCreatorDialog;